import React, { useState } from 'react';
import { Clock, Music, Users, Star, Sparkles, Calendar, Infinity } from 'lucide-react';
import { 
  EventTimingProvider, 
  FiguresTab, 
  CompulsoryDanceTab, 
  FreedanceStyledanceTab,
  FreeskatingTab,
  TeamsTab,
  CompetitionBreaksTab,
  TimeBlocksTab 
} from '@/components/event-timing';
import StaleLinksBanner from '@/components/event-timing/StaleLinksBanner';

// Tab configuration
const tabs = [
  { id: 'figures', label: 'Figures & Loops', icon: Infinity },
  { id: 'compulsory-dance', label: 'Compulsory Dance', icon: Music },
  { id: 'freedance', label: 'Freedance', icon: Sparkles },
  { id: 'styledance', label: 'Styledance', icon: Star },
  { id: 'freeskating', label: 'Freeskating & Freeskating Inline', icon: Sparkles, mirrored: true },
  { id: 'teams', label: 'Teams', icon: Users },
  { id: 'special-events', label: 'Competition Breaks', icon: Calendar },
  { id: 'time-blocks', label: 'Order of Skate Settings', icon: Clock },
];

export default function EventTimingPage() {
  const [activeTab, setActiveTab] = useState('figures');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'figures':
        return <FiguresTab />;
      case 'compulsory-dance':
        return <CompulsoryDanceTab />;
      case 'freedance':
        return <FreedanceStyledanceTab eventType="freedance" />;
      case 'styledance':
        return <FreedanceStyledanceTab eventType="styledance" />;
      case 'freeskating':
        return <FreeskatingTab />;
      case 'teams':
        return <TeamsTab />;
      case 'special-events':
        return <CompetitionBreaksTab />;
      case 'time-blocks':
        return <TimeBlocksTab />;
      default:
        return <TimeBlocksTab />;
    }
  };

  return (
    <EventTimingProvider>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold" style={{ color: '#2D4A3E' }}>Event Timing</h1>
          <p className="text-muted-foreground mt-1">Configure timing parameters for different event types</p>
        </div>

        {/* Stale-grade-link health check: hides itself when all healthy. */}
        <StaleLinksBanner />
        
        {/* Tab Navigation */}
        <div className="border-b border-stone-200">
          <div className="flex gap-1 overflow-x-auto">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  data-testid={`tab-${tab.id}`}
                  className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors whitespace-nowrap ${
                    isActive 
                      ? 'border-[#2D4A3E] text-[#2D4A3E] font-medium' 
                      : 'border-transparent text-muted-foreground hover:text-foreground hover:border-stone-300'
                  }`}
                >
                  <Icon className="h-4 w-4" style={tab.mirrored ? { transform: 'scaleX(-1)' } : undefined} />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
        
        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </EventTimingProvider>
  );
}
